import React, { useState } from 'react';
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Menu, Col, Row, Modal, Dropdown, notification } from 'antd';
import { WIFIPage } from '../MobileDevice';
import IPConfigPage from '../IPConfigPage';
import { SmartBulbConfig } from './SmartBulb';
import { AirConditionerConfig } from './AirConditioner';
import { bluethoothEnviroment, BLUETHOOTH_SERVICE } from '../../Device/Simulator/Bluethooth';
import { DeviceType } from '../../Device/Simulator/Base';
import { ProjectorConfig } from './Projector';
import { ScreenConfig } from './Screen';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { AVAILABE_INFRARED_RAY_DEVICE_TYPES, AVAILABE_INFRARED_RAY_DEVICE_TYPE_NAME_MAP } from '../../Device/Simulator/InfraredRay';

// 蓝牙配对面板
function Bluetooth(props) {
    const { device } = props;

    // version版本号，单调递增，用于刷新页面
    const [version, setVersion] = useState(0);

    // 获取已配对设备
    const pairedDevices = device.getPairedBluetoothDevice();

    // 获取可用设备
    const availableDevices = device.scanBluetoothDevice();

    // console.log('pairedDevices', pairedDevices);
    // console.log('availableDevices', availableDevices)

    const { bluethoothGateway } = device;
    const connectDevice = (device) => {
        bluethoothGateway.connect(device);
        setVersion(version + 1);
    }

    const disconnectDevice = (MACAddress) => {
        try {
            // 设备还在的就断开
            const device = bluethoothEnviroment.getDeviceByMAC(MACAddress);
            bluethoothGateway.disconnect(device);
        }
        catch(e) {
            // 设备不再直接删除
            bluethoothGateway.disconnectByMAC(MACAddress);
        }

        setVersion(version + 1);
    }

    return (
        <div style={{ padding: '10px 20px', backgroundColor: 'white', height: '60%', marginTop: '10px', overflowX: 'hidden', overflowY: 'auto' }}>
            <div style={{ margin: '20px 0' }}>
                <div style={{ fontSize: '12px' }}>已配对设备</div>
                <div style={{ height: '1px', background: '#e8e8e8', margin: '10px 0' }}></div>
                {
                    pairedDevices.map(device => {
                        const { deviceName = '', MACAddress = '' } = device;
    
                        return (
                            <Row key={MACAddress} style={{ cursor: 'pointer' }} align="middle" >
                                <Col span={22}>
                                    <div style={{ fontWeight: 600, fontSize: '14px' }} title={MACAddress}>{deviceName}</div>
                                </Col>
                                <Col span={2}>
                                      <Dropdown trigger={['click']}
                                        overlay={
                                            <Menu>
                                                <Menu.Item 
                                                  onClick={() => {
                                                    disconnectDevice(MACAddress);
                                                }}>
                                                    <div>断开连接</div>
                                                </Menu.Item>
                                            </Menu>
                                        }
                                      >
                                        <a className="ant-dropdown-link" href="/" onClick={e => e.preventDefault()}>
                                            <InfoCircleOutlined style={{margin: '10px', fontSize:'20px', lineHeight: '20px'}}/>
                                        </a>
                                      </Dropdown>
                                </Col>
                            </Row>
                        );
                    })
            
                }
            </div>

            <div style={{ margin: '20px 0' }}>
                <div style={{ fontSize: '12px' }}>可用设备</div>
                <div style={{ height: '1px', background: '#e8e8e8', margin: '10px 0' }}></div>
                {
                    availableDevices.map(device => {
                        const { deviceConfig: { deviceName, MACAddress } = {} } = device;
    
                        return (
                            <Row key={MACAddress} style={{ cursor: 'pointer' }} align="middle" onClick={() => { 
                                connectDevice(device);
                            }}>
                                <Col span={22}>
                                    <div style={{ fontWeight: 600, fontSize: '14px' }} title={MACAddress}>{deviceName}</div>
                                </Col>
                            </Row>
                        );
                    })
            
                }
            </div>
        </div>
    )       
}

// 红外连接面板
function InfraredDevices(props) {
    const { device } = props;

    // version版本号，单调递增，用于刷新页面
    const [version, setVersion] = useState(0);

    const infraredSignalRecords = device.getInfraredSignalRecords();

    return (
        <div style={{ padding: '10px 20px', backgroundColor: 'white', height: '60%', marginTop: '10px' }}>
            {/* 已添加红外设备列表 */}
            <div style={{ margin: '20px 0' }}>
                <div style={{ fontSize: '12px' }}>已添加红外信号面板</div>
                <div style={{ height: '1px', background: '#e8e8e8', margin: '10px 0' }}></div>

                {
                    infraredSignalRecords.map(infraredSignalRecord => {
                        const { deviceType, deviceName } = infraredSignalRecord;

                        return (
                            <Row style={{ cursor: 'pointer' }} align="middle" key={deviceName}>
                                <Col span={22}>
                                    <div style={{ fontWeight: 600, fontSize: '14px' }} key={deviceType}>{deviceName}</div>
                                </Col>
                                <Col span={2}>
                                    <Dropdown trigger={['click']}
                                        overlay={  
                                            <Menu>
                                                <Menu.Item
                                                    onClick={() => {
                                                        try {
                                                            device.removeInfraredSignalRecord(deviceType, deviceName);
                                                        }
                                                        catch (e) {
                                                            notification.error({
                                                                message: '删除失败',
                                                                description: e.message,
                                                            });
                                                        }

                                                        setVersion(version + 1);
                                                    }}
                                                >
                                                    <div>删除设备</div>
                                                </Menu.Item>
                                            </Menu>
                                        }
                                    >
                                        <a className="ant-dropdown-link" href="/" onClick={e => e.preventDefault()}>
                                            <InfoCircleOutlined style={{margin: '10px', fontSize:'20px', lineHeight: '20px'}}/>
                                        </a>
                                    </Dropdown>
                                </Col>
                            </Row>
                        );
                    })
                }
            </div>
            {
                <div style={{ position: 'absolute', bottom: '20px', right: '20px', width: '40px', height: '40px', borderRadius: '50%', background: '#1890ff', color: 'white', textAlign: 'center', lineHeight: '30px', fontSize: '40px', fontWeight: 600 }}>
                <Dropdown
                    trigger={['click']}
                    placement="topCenter"
                    overlay={
                        <Menu>
                            {
                                AVAILABE_INFRARED_RAY_DEVICE_TYPES.map(deviceType => {
                                    return (
                                        <Menu.Item
                                            onClick={() => {
                                                // const deviceName = window.prompt("请输入设备名称", AVAILABE_INFRARED_RAY_DEVICE_TYPE_NAME_MAP[deviceType]);
                                                const deviceName = AVAILABE_INFRARED_RAY_DEVICE_TYPE_NAME_MAP[deviceType];
                                                if(!deviceName) {
                                                    return;
                                                }

                                                try {
                                                    device.addInfraredSignalRecord(deviceType, deviceName);
                                                }
                                                catch (e) {
                                                    notification.error({
                                                        message: '添加失败',
                                                        description: e.message,
                                                    });
                                                }
                                                setVersion(version + 1);
                                            }}
                                            key={deviceType}
                                        >
                                            {AVAILABE_INFRARED_RAY_DEVICE_TYPE_NAME_MAP[deviceType]}
                                        </Menu.Item>
                                    )
                                })
                            }
                        </Menu>
                    }
                >
                    <div>
                        <PlusOutlined style={{ fontSize: '30px', fontWeight: 600 }} />
                    </div>
                    </Dropdown>
                </div>
            }
        </div>
    )
}

const HomePage = (props) => {
    const { device: masterDevice } = props;
    const { bluethoothGateway } = masterDevice;

    const [currentDevice, setCurrentDevice] = useState({});
    const [visible, setVisible] = useState(false);

    // 获取已配对设备
    const pairedBluetoothDevices = masterDevice.getPairedBluetoothDevice();

    // 获取已添加红外设备
    const infraredSignalRecords = masterDevice.getInfraredSignalRecords();
    const pairedDevices = [...pairedBluetoothDevices, ...infraredSignalRecords];

    // 获取事件列表
    const events = bluethoothGateway.getEvents();

    const commandMap = {
        [DeviceType.SmartBulb]: BLUETHOOTH_SERVICE.SMART_BULB_SET,
    };

    const onClose = (values) => {
        if (commandMap[currentDevice.deviceType]) {
            masterDevice.sendBluetoothCommand(currentDevice, commandMap[currentDevice.deviceType], values);
        }
      
        setVisible(false);
    }

    const configMap = {
        [DeviceType.SmartBulb]: <SmartBulbConfig masterDevice={masterDevice} device={currentDevice} onClose={onClose} />,
        [DeviceType.AirConditioner]: <AirConditionerConfig masterDevice={masterDevice} device={currentDevice} onClose={onClose} />,
        [DeviceType.Projector]: <ProjectorConfig masterDevice={masterDevice} device={currentDevice} onClose={onClose} />,
        [DeviceType.Screen]: <ScreenConfig masterDevice={masterDevice} device={currentDevice} onClose={onClose} />,
    };

    const targetContent = configMap[currentDevice.deviceType];

    return (
        <div style={{ height: '580px' }}>
            <Modal
                title="设备配置"
                visible={visible}
                onCancel={() => { 
                    setVisible(false);
                }}
                width={'80vw'}
                height={'50vh'}
                footer={null}
            >
               <div style={{ padding: '10px 20px', backgroundColor: 'white', height: '30%', marginTop: '10px' }}>
                <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: '600' }}>{currentDevice.deviceName}</div>
                {
                    targetContent ?
                        <div style={{ textAlign: 'center', fontSize: '12px', color: '#999' }}>
                            {targetContent}
                        </div>
                    : null
                }
            </div>
            </Modal>
 
            <div style={{ padding: '10px 20px', backgroundColor: 'white', height: '70%', marginTop: '10px', overflowX: 'hidden', overflowY: 'auto' }}>
                <div style={{ height: '200px', overflow: 'auto' }}>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            gridGap: '10px',
                            gridAutoRows: 'minmax(100px, auto)',
                        }}>
                        {
                            pairedDevices && pairedDevices.length ? pairedDevices.map(device => {
                                const { deviceType, MACAddress, deviceName = '' } = device;

                                const sameDevice = MACAddress ? currentDevice.MACAddress === MACAddress : currentDevice.deviceName === deviceName;

                                return (
                                    <div 
                                    title={deviceName} 
                                    style={{ backgroundColor: sameDevice ? '#b7d6ea' : 'white', padding: '10px', borderRadius: '5px', cursor: 'pointer', border: '1px solid #d2cece', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }} 
                                    key={MACAddress || deviceName} 
                                    onClick={() => {
                                        setCurrentDevice(device);
                                        configMap[deviceType] && setVisible(true);
                                    }}>
                                        <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: '600' }}>
                                            <div style={{ textOverflow: 'ellipsis' }}>{deviceName}</div>
                                        </div>
                                    </div>
                                );
                            })
                            : '暂无设备'
                        }
                    </div>
                </div>
                <div style={{ height: '1px', backgroundColor: '#d2cece', marginTop: '10px' }}></div>
                
                <div style={{
                    height: '150px',
                    overflow: 'auto',
                    position: 'absolute',
                    bottom: '40px',
                    width: '90%'
                }}>
                    {
                        events && events.length ? 
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        {
                            
                            events.map(event => {
                                const { when, level, message = '' } = event;
    
                                return (
                                    <div key={Math.random()} style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                                        <div style={{ color: level, fontSize: '20px', fontWeight: 800, marginRight: '5px' }}>.</div>
                                        <div style={{ marginRight: '5px' }} title={moment(when).format('YYYY-MM-DD HH:mm:ss')}>{moment(when).fromNow()}</div>
                                        <div>{message}</div>
                                    </div>
                                );
                            })
                        }
                        </div>
                        : '暂无消息'
                    }
                </div>
            </div>                                            
        </div>
    )
};

const ConfigPage = (props) => {
    const { device } = props;
    const { mobileDevice } = device;

    const [menuKey, setMenuKey] = useState('蓝牙配对');

    const style = {
        width: '90px',
        height: '35px',
        background: '#C2D1E8',
        borderRadius: '36px',
        textAlign: 'center',
        lineHeight: '36px'
    }

    return (
        <div style={{ height: '587px' }}>
            <Menu onClick={(e) => setMenuKey(e.key)} selectedKeys={[menuKey]} defaultSelectedKeys={['连接']} mode="horizontal"
            style={{
                background: 'rgb(236, 243, 250)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '10px 0'
            }}>
                <Menu.Item key="蓝牙配对" style={style}>
                蓝牙配对
                </Menu.Item>
                <Menu.Item key="红外遥控" style={style}>
                红外遥控
                </Menu.Item>
            </Menu>
            <hr style={{color: '#D5DDE5',}}></hr>
            { menuKey === '无线网络' ? <WIFIPage device={mobileDevice} />:null}
            { menuKey === 'IP配置' ? <IPConfigPage device={mobileDevice} />:null}
            { menuKey === '蓝牙配对' ? <Bluetooth {...props} />:null}
            { menuKey === '红外遥控' ? <InfraredDevices {...props} />:null}
        </div>
    )
}

function SmartSpeaker (props) {
    const [menuKey, setMenuKey] = useState('主页');

    return (
        <div
        style={{
          width: '461px',
          height: '587px',
          background: '#408CEE',
          borderRadius: '38px',
          margin: '0 auto',
          paddingTop: '10px',
        }}>
          <div style={{
              width: '82px',
              height: '10px',
              background: '#071C38',
              borderRadius: '5px',
              margin: '10px auto',
          }}></div>
          <div 
            style={{
              padding: '10px',
              borderRadius: '20px',
              backgroundColor: '#ecf3fb',
              width: '426px',
              height: '500px',
              margin: '20px auto',
              position: 'relative',
            }}
          >
            <style>
                {`
                    .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu
                    {
                        margin: 0 5px;
                    }

                    .ant-menu-horizontal {
                        background: #ecf3fb;
                    }
                `}
            </style>
            <Menu onClick={(e) => setMenuKey(e.key)} selectedKeys={[menuKey]} defaultSelectedKeys={['主页']} mode="horizontal" style={{ backgroundColor: '#fff !important' }}>
                <Menu.Item key="主页" 
                style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    }}
                    >
                主页
                </Menu.Item>
                <Menu.Item key="配置" 
                style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    }}
                    >
                配置
                </Menu.Item>
            </Menu>
            <div>
                {
                    menuKey === '主页' ? <HomePage {...props} /> : null
                }

                {
                    menuKey === '配置' ? <ConfigPage {...props} /> : null
                }
            </div>

          </div>
        </div>
    );
}

export default SmartSpeaker;
